module.exports = __webpack_public_path__ + "img/futureWill1.44291138.png";